export const Routes = {
  dashboard: '/',
  login: '/login',
  logout: '/logout',
  customer: '/customer/:id',
};
